module.exports = __webpack_public_path__ + "img/clarity_phone-handset-line.25567b70.svg";